module.exports = __webpack_public_path__ + "img/4.金赛性学报告（艾弥儿）.fed7fe30.jpg";